var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      { staticClass: "mb-2" },
      [
        !_vm.isReadOnlyOrNoManage || _vm.canDownloadItems
          ? _c(
              "b-row",
              { staticClass: "mb-1" },
              [
                _c(
                  "b-col",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _vm.canDownloadItems
                      ? _c("e-button", {
                          staticClass: "mr-1",
                          attrs: {
                            id: "download-items",
                            text: _vm.$t("Baixar Planilha"),
                            variant: "primary",
                            icon: "download",
                            busy: _vm.downloading,
                          },
                          on: { click: _vm.onDownloadItems },
                        })
                      : _vm._e(),
                    !_vm.isReadOnlyOrNoManage
                      ? _c("e-button", {
                          attrs: {
                            text: _vm.$t("Adicionar item"),
                            variant: "primary",
                          },
                          on: { click: _vm.onAddItem },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "b-row",
          [
            _c(
              "b-col",
              [
                _c(
                  "FormulateForm",
                  { ref: "formulateOrderItems" },
                  [
                    _c("b-table", {
                      ref: "productTable",
                      staticClass: "bordered",
                      staticStyle: { "max-height": "500px !important" },
                      attrs: {
                        "show-empty": "",
                        striped: "",
                        fields: _vm.fields,
                        items: _vm.items,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "cell(action)",
                          fn: function (row) {
                            return [
                              _c("e-grid-actions", {
                                attrs: {
                                  "show-update": false,
                                  "show-delete": !_vm.readOnly,
                                },
                                on: {
                                  delete: function ($event) {
                                    return _vm.onRemoveItem(row.item)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "cell(quantity)",
                          fn: function (row) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  !_vm.isReadOnlyOrNoManage
                                    ? _c("FormulateInput", {
                                        staticClass: "text-right",
                                        staticStyle: { width: "80px" },
                                        attrs: {
                                          id:
                                            "order-items-quantity-" + row.index,
                                          type: "text-number",
                                          precision: 0,
                                          title: _vm.$t("Clique para editar"),
                                          validation: "required|min:1",
                                          "validation-messages": {
                                            required: _vm.$t("Obrigatório"),
                                            min: _vm.$t(
                                              "Deve ser maior que zero"
                                            ),
                                          },
                                        },
                                        model: {
                                          value: row.item.quantity,
                                          callback: function ($$v) {
                                            _vm.$set(row.item, "quantity", $$v)
                                          },
                                          expression: "row.item.quantity",
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("number")(
                                              row.item.quantity,
                                              0
                                            )
                                          )
                                        ),
                                      ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(packs)",
                          fn: function (row) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(_vm.getPackQuantity(row.item))),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "head(adjustedQuantity)",
                          fn: function (data) {
                            return [
                              _c("span", [_vm._v(_vm._s(data.label))]),
                              _c("e-instructions", {
                                attrs: {
                                  "container-class": "ml-1",
                                  target: "instruction_adjusted_quantity",
                                  title: _vm.$t("Qtd. Ajustada"),
                                  instruction: _vm.$t(
                                    "Quantidade de packs arredondada para cima, ou seja, o total de packs inteiros necessários para atender a quantidade solicitada."
                                  ),
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "cell(adjustedQuantity)",
                          fn: function (row) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getAdjustedQuantity(row.item))
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }